import { cn } from "@rarible_int/anaconda_ui_components"

const gachaCtaButtonLayoutClassName = "h-auto min-h-9 px-3 py-2.5"

export const gachaCtaButtonTypographyClassName =
  "text-[0.875rem] !leading-snug antialiased [font-synthesis-weight:none] [&_*]:!text-[0.875rem] [&_*]:!leading-snug"

export const gachaCtaButtonPrimaryLabelClassName = "!font-bold [&_*]:!font-bold"

export const gachaCtaButtonOutlineLabelClassName =
  gachaCtaButtonPrimaryLabelClassName

export const gachaCtaButtonClassName = cn(
  gachaCtaButtonLayoutClassName,
  gachaCtaButtonTypographyClassName,
  gachaCtaButtonPrimaryLabelClassName,
)

export const gachaCtaButtonFullWidthClassName = cn(
  gachaCtaButtonClassName,
  "w-full min-w-0",
)

export const gachaCtaButtonRowClassName = cn(
  gachaCtaButtonClassName,
  "w-full flex-1 sm:min-w-0",
)

export const gachaOutlineCtaButtonClassName = cn(
  gachaCtaButtonLayoutClassName,
  gachaCtaButtonTypographyClassName,
  gachaCtaButtonOutlineLabelClassName,
  "text-foreground [&_*]:text-foreground",
)

export const gachaPrimaryCtaButtonClassName = cn(
  gachaCtaButtonRowClassName,
  "text-center whitespace-normal text-primary-foreground [&_*]:text-primary-foreground",
)

export const gachaPrimaryCtaButtonFullWidthClassName = cn(
  gachaCtaButtonFullWidthClassName,
  "text-center whitespace-normal",
)

export const gachaDialogFooterClassName =
  "flex flex-col gap-2 sm:flex-row sm:items-center sm:gap-2 sm:space-x-0"

export const gachaCtaButtonRowSecondaryPaddingClassName = "px-4"

const gachaCtaButtonRowSecondaryOutlineClassName = cn(
  gachaCtaButtonLayoutClassName,
  gachaCtaButtonTypographyClassName,
  gachaCtaButtonOutlineLabelClassName,
  "text-center !whitespace-normal text-foreground [&_*]:text-foreground",
  gachaCtaButtonRowSecondaryPaddingClassName,
  "order-2 h-auto min-h-10 w-full sm:order-1 sm:w-auto sm:max-w-none sm:shrink-0",
)

export const gachaCtaButtonRowSecondaryClassName = cn(
  gachaCtaButtonRowSecondaryOutlineClassName,
  "sm:min-w-[7.5rem]",
)

export const gachaCtaButtonRowSecondaryAutoClassName =
  gachaCtaButtonRowSecondaryOutlineClassName

export const gachaCtaButtonRowPrimaryClassName = cn(
  gachaPrimaryCtaButtonClassName,
  "order-1 h-10 min-h-10 w-full sm:order-2 sm:min-w-0 sm:flex-1",
)

export const gachaPrimaryCtaButtonCompactClassName = cn(
  gachaPrimaryCtaButtonFullWidthClassName,
  "h-9 min-h-9",
)

export const gachaOutlineCtaButtonCompactClassName = cn(
  gachaOutlineCtaButtonClassName,
  "h-9 min-h-9",
)
